var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box_12 flex-col"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.info.companyLogoUrl),expression:"info.companyLogoUrl"}],attrs:{"alt":""}}),_c('span',{staticClass:"text_111"},[_vm._v(_vm._s(_vm.info.serviceName))]),_c('span',{staticClass:"text_112"},[_vm._v("/"+_vm._s(_vm.info.companyName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }